import React from "react";
import { useCm } from "./CmProvider";
import { MessageFilled, QrcodeOutlined, ReloadOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { Layout, Button, Popconfirm, Empty, Card, Grid, Row, Col, QRCode, Input, Typography } from "antd";
import dayjs from "dayjs";

const headerStyle = {
    textAlign: 'left',
    color: '#fff',
    height: 48,
    paddingInline: 48,
    lineHeight: '48px',
    fontSize: 32,
    backgroundColor: '#00B900',
  };
  
function ContainerStatus({ container, info }) {
    let title = info.state
    let description = container.containerStatus
    //container.state = "Wait for PIN: 999999"//
    if (info.state.match(/^Ready /)) {
        title = <><span style={{ color: '#009900' }}>พร้อมทำงาน [{info.state.replace(/^Ready /, '')}]</span></>
    } else
    if (info.state.match(/^Wait for PIN: /)) {
        title = <><span style={{ color: '#990000' }}>รอรหัส: {info.state.replace(/^Wait for PIN: /, '')}</span></>
        description = <span style={{ color: '#990000' }}>กรอกรหัสใน LINE {container.state.replace(/^Wait for PIN: /, '')}</span>
    } else
    if (info.state.match(/^exited/)) {
        title = <><span style={{ color: '#990000' }}>หยุดทำงาน</span></>
        description = <span style={{ color: '#990000' }}>ลองกด Restart</span>
    }

    return <Card.Meta
        title={<div style={{ display: 'flex' }}>สถานะ:&nbsp;{title} </div>}
        description={description}
    />
}

function LatestMessage({ info }) {

    if (!info.msg) {
        return null;
    }

    return <Typography.Paragraph>
        
         <span style={{ color: '#009900' }}><MessageFilled /> {info.msg}</span> <span style={{ color: '#999' }}>({dayjs(info.msgTime).fromNow()})</span>

    </Typography.Paragraph>
}

function ContainerData({ container }) {
    const { restart, loading } = useCm();
    let info = { state: container.containerState, version: "-", msg: '', msgTime: '' }
    
    try{
        const state = JSON.parse(container.state)
        info.state = state.state
        info.version = state.version
        info.msg = state.msg
        info.msgTime = state.msgTime
    }catch(e){
        console.log(e)
    }

    return <Card
        size="small"
        title={<div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flex: 1 }}>[{container.party}] - {container.account_no}</div>
            <div style={{ display: 'flex', flex: 0, fontWeight: 'normal', fontSize: "0.8rem", lineHeight: "1rem", color: "#999", textAlign: "right" }}>v{info.version}</div>
        </div>}
        actions={[
            <Popconfirm
                title="ต้องการ restart การเชื่อมต่อ?"
                description="ต้องทำการเข้าระบบใหม่ เตรียมมือถือ Line ให้พร้อม เพื่อกรอกรหัส"
                onConfirm={() => restart(container.party, container.account_no)}
                key="tool"
                >
                <Button
                    size="small"
                    type="primary"
                    icon={<QrcodeOutlined />}
                    loading={loading == `restart-${container.account_no}`} disabled={!!loading} >Restart / Upgrade</Button>
            </Popconfirm>
        ]}
    >
        <ContainerStatus container={container} info={info} />
        <LatestMessage info={info} />
    </Card>   
}

export default function ManagerPage() {
    const { containers, reload, rebuild, loading } = useCm();
    const [filter, setFilter] = React.useState('');
    
    // const containers_ = [...containers];//, ...containers, ...containers, ...containers, ...containers, ...containers, ...containers, ];
    const containers_ = containers.filter((c) => {
        return c.account_no.toLowerCase().includes(filter.toLowerCase()) || c.party.toLowerCase().includes(filter.toLowerCase())
    });

    
    return <Layout>
        <Layout.Header style={headerStyle}>
            LinxTx Manager
        </Layout.Header>
        <Layout.Content style={{ padding: '30px', minHeight: "90vh" }}>
            <Row>
                <Col flex="auto">
                    <Button 
                        loading={loading == 'status'} disabled={!!loading}
                        type="primary" icon={<ReloadOutlined />} onClick={() => reload(true)}>Refresh</Button>&nbsp;
                    <Popconfirm
                        title="ยืนยันการเปลี่ยนแปลง?"
                        description="การ Build จะทำเมื่อมีการเพิ่ม หรือลดบัญชีเท่านั้น"
                        onConfirm={rebuild}
                        // onOpenChange={() => console.log('open change')}
                        >
                        <Button loading={loading == 'rebuild'} disabled={!!loading} color="danger" variant="solid" icon={<ThunderboltOutlined />} >Build</Button>&nbsp;
                    </Popconfirm>
                </Col>
                <Col  flex="auto" style={{ textAlign: 'right' }}>
                    <Input placeholder="ค้นหา" value={filter} onChange={(e) => setFilter(e.target.value)} />
                </Col>
            </Row>

            {containers_.length == 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
            <Row gutter={[8, 8]} style={{ marginTop: 16 }}>
                {containers_.map((c) => {
                    return <Col xs={24} sm={12} md={12} lg={8}><ContainerData container={c} key={c.name} /></Col>
                })}
            </Row>
        </Layout.Content>
        
        <Layout.Footer style={{ textAlign: 'center' }}>
        prawitz©2024
        </Layout.Footer>
    </Layout>
}